export default [

    {
    	path:'/qushi',
    	name:'qushi',
    	component:() => import('@/views/qushi'),
        meta: {

            keepAlive: true, //此组件需要被缓存
            isBack:false,
        }
    },
    
]


// WEBPACK FOOTER //
// ./src/router/qushi.js